import ReactDOM from "react-dom"

// normalize CSS across browsers
import "./src/normalize.scss"
// custom CSS styles
import "./src/style.scss"

export function replaceHydrateFunction() {
    return (element, container, callback) => {
        ReactDOM.render(element, container, callback)
    }
}

export const onClientEntry = () => {
  // Script de correction de viewport supprimé pour éviter les problèmes de scrollbar sur Windows
  function fixIOSViewport() {
    const width = window.innerWidth; // largeur réelle du viewport visuel iOS
    document.documentElement.style.width = width + "px";
    document.body.style.width = width + "px";
  }

  fixIOSViewport(); // dès le chargement
  window.addEventListener("resize", fixIOSViewport); 
};
